import React, { useState, useEffect } from 'react';
import ReactTypingEffect from 'react-typing-effect';
import ScrollAnimation from 'react-animate-on-scroll';
import computer from '../images/computer_banner.png';
import linkedin from '../images/linkedin.png';
import "animate.css/animate.min.css";
import emailjs from '@emailjs/browser';

const resume = "https://drive.google.com/drive/folders/1lhR9vXQ-mCEwSA9dOcNsaaSkYyxO8-MV?usp=sharing";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [status, setStatus] = useState('');

  useEffect(() => {
    // Initialize EmailJS - exactly like your working code
    (function() {
      emailjs.init("IF36fQ7C2MK2KwIvG");
    })();
  }, []);

  const handleSendMessage = (e) => {
    e.preventDefault();

    const serviceID = "service_7czszst";
    const templateID = "template_h35nibi";

    // Gather form data - exactly like your working code
    const templateParams = {
      name: document.querySelector('input[name="name"]').value,
      email: document.querySelector('input[name="email"]').value,
      message: document.querySelector('textarea[name="message"]').value
    };

    console.log('Sending email with params:', templateParams);

    // Send email - exactly like your working code
    emailjs.send(serviceID, templateID, templateParams)
      .then(response => {
        console.log('EmailJS Success:', response);
        setStatus('SUCCESS');
        
        // Reset form
        document.querySelector('input[name="name"]').value = '';
        document.querySelector('input[name="email"]').value = '';
        document.querySelector('textarea[name="message"]').value = '';
      })
      .catch(error => {
        console.error('EmailJS Error:', error);
        setStatus('FAILED');
      });
  };

  return (
    <footer className='slide-in-element' aria-label="Site Footer">
        <div className="max-w-screen-xl px-4 pb-8 mx-auto sm:px-6 lg:px-8">
          <div>
            <div className="font-[sans-serif] pt-8">
              <div className="bg-gradient-to-r from-blue-700 to-blue-300 w-full h-90">
                <img src={computer} style={{ objectFit: 'cover' }} alt="Banner Image" className="w-full h-full object-cover" />
              </div>
              <div className="-mt-28 md:-mt-48 mb-6 px-4">
                <div className="mx-auto max-w-5xl shadow-lg py-12 px-12 relative bg-white rounded-3xl border-2 border-black dark:border-black-300">
                  <form className="grid sm:grid-cols-2 gap-6" onSubmit={handleSendMessage}>
                    <div>
                      <label className="font-mono font-semibold text-sm text-left">
                        <h6>Your Name</h6>
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="John Doe"
                        required
                        className="font-mono w-full py-2.5 px-4 mt-2 border-2 text-sm outline-[#007bff]"
                      />
                    </div>
                    <div>
                      <label className="font-mono font-semibold text-sm">
                        <h6>Your Email</h6>
                      </label>
                      <input
                        type="email"
                        name="email"
                        placeholder="recruiter@company.com"
                        required
                        className="font-mono w-full py-2.5 px-4 border-2 mt-2 text-sm outline-[#007bff]"
                      />
                    </div>
                    <div className="col-span-full">
                      <label className="font-mono font-semibold text-sm">
                        <h6>Message</h6>
                      </label>
                      <textarea
                        name="message"
                        placeholder="Let's Work Together"
                        rows="6"
                        required
                        className="font-mono w-full px-4 border-2 mt-2 text-sm pt-3 outline-[#007bff]"
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="cursor-pointer rounded-full font-mono text-white w-max bg-[#000] hover:bg-blue-600 font-semibold text-sm px-6 py-3 transition duration-300 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16px"
                        height="16px"
                        fill="#fff"
                        className="cursor-pointer mr-2 inline"
                        viewBox="0 0 548.244 548.244"
                      >
                        <path
                          fillRule="evenodd"
                          d="M392.19 156.054 211.268 281.667 22.032 218.58C8.823 214.168-.076 201.775 0 187.852c.077-13.923 9.078-26.24 22.338-30.498L506.15 1.549c11.5-3.697 24.123-.663 32.666 7.88 8.542 8.543 11.577 21.165 7.879 32.666L390.89 525.906c-4.258 13.26-16.575 22.261-30.498 22.338-13.923.076-26.316-8.823-30.728-22.032l-63.393-190.153z"
                          clipRule="evenodd"
                          className='cursor-pointer'
                        />
                      </svg>
                      <h6 className='cursor-pointer'>Send Message</h6>
                    </button>
                  </form>
                  {status === 'SUCCESS' && <h2 className="text-green-800 mt-4 font-bold text-lg">Message sent successfully!</h2>}
                  {status === 'FAILED' && <h2 className="text-red-400 mt-4 font-bold text-lg">Failed to send message. Please try again.</h2>}
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center mt-9"></div>
          </div>
          <div>
            <hr className='mt-12 mb-8' style={{ borderTop: "2px dashed black" }}></hr>
            <h2 className='last-text text-center'>Every Interaction Shapes an <span className='italic'>* Experience *</span></h2>
          </div>
          <div className="pt-8 mt-8 sm:flex sm:items-center sm:justify-between lg:mt-12">
            <nav aria-label="Footer Navigation - Support">
              <ul className="cursor-pointer flex flex-wrap justify-center gap-4 text-xs lg:justify-end">
                <li>
                  <a href={resume} target="_blank" className="cursor-pointer text-black-200 transition hover:opacity-75">
                    Resume
                  </a>
                </li>
                <li>
                  <a href="/about" className="cursor-pointer text-black-200 transition hover:opacity-75">
                    About
                  </a>
                </li>
              </ul>
            </nav>
            <ul className="flex justify-center gap-6 mt-8 sm:mt-0 lg:justify-center cursor-pointer">
              <div className='text-black-200 text-xs'>
                © {currentYear} Rabii • Made with { }
                <ReactTypingEffect
                  text={["Love ♥", "Passion ⭑.ᐟ"]}
                  speed={150}
                  eraseDelay={3000}
                  typingDelay={1000}
                  cursor="_"
                />
              </div>
            </ul>
            <ul className="flex justify-center gap-6 mt-8 sm:mt-0 lg:justify-end cursor-pointer">
              <li>
                <a
                  href="https://www.linkedin.com/in/rabiialaoui/"
                  rel="noreferrer"
                  target="_blank"
                  className="text-black-200 transition hover:opacity-75 cursor-pointer"
                >
                  <span className="sr-only cursor-pointer">Linkedin</span>
                  <img
                    src={linkedin} 
                    alt="Linkedin"
                    className="w-6 h-6 cursor-pointer"
                  />
                </a>
              </li>


              <li>
                <a
                  href="https://github.com/RabiiAlaouiLamharzi"
                  rel="noreferrer"
                  target="_blank"
                  className="text-black-200 transition hover:opacity-75 cursor-pointer"
                >
                  <span className="sr-only cursor-pointer">GitHub</span>

                  <svg
                    className="w-6 h-6 cursor-pointer"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      clipRule="evenodd"
                      className='cursor-pointer'
                    />
                  </svg>
                </a>
              </li>
            </ul>
    </div>
  </div>
</footer>


  );
};

export default Footer;